<template>
  <el-config-provider :locale="zhCn">
    <div :class="['app-container', { 'dark-mode': isDarkMode }]">
      <FullScreenLoader :simulateLoad="true" :dark-mode="isDarkMode" />
      <router-view />
    </div>
  </el-config-provider>
</template>

<script setup lang="ts">
import { provide } from 'vue'
import { ElConfigProvider } from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'

import FullScreenLoader from '@/components/FullScreenLoader.vue'

// 暗黑模式
import { useDarkMode } from '@/hooks/usePersistentDark'

const { isDarkMode, toggleDarkMode } = useDarkMode()
// 提供全局方法给子组件
const provideDarkMode = () => {
  return {
    isDarkMode,
    toggleDarkMode,
  }
}

provide('darkMode', provideDarkMode())
</script>

<style>
.app-container {
  height: 100vh;
  /* 滚动容器：原 Layout 的 el-scrollbar 已随模块精简移除，由本容器承接页面滚动 */
  overflow-y: auto;
  transition: background-color 0.3s;
}

.dark-mode {
  --el-bg-color: #141414;
  --el-bg-color-page: #0a0a0a;
  --el-bg-color-overlay: #1d1e1f;
  --el-text-color-primary: #e5eaf3;
  --el-text-color-regular: #cfd3dc;
  --el-border-color-light: #414243;
}
</style>
